import React from "react"
import Typography from "aldoo-ra/Typography"
import { CheckIcon } from "@heroicons/react/24/outline"
import { twMerge } from "tailwind-merge"

const StepHeader = ({ steps, currentStep, onStepClick }) => {
  return (
    <div className="xl:px-48 pt-8 pb-6">
      <div className="flex items-center justify-center">
        <div className="flex items-center">
          {steps.map((step, index) => (
            <div key={step.number} className="flex items-center">
              <div className="flex flex-col items-center">
                <button
                  className={twMerge(
                    "w-12 h-12 rounded-full flex items-center justify-center font-semibold text-sm transition-all duration-200 border-2",
                    step.number <= currentStep
                      ? "bg-admin_primary text-white border-white shadow-md"
                      : "bg-white text-admin_text_secondary border-admin_neutral_2 hover:border-admin_primary/30",
                    step.number < currentStep
                      ? "cursor-pointer hover:bg-admin_primary/90 hover:scale-105"
                      : step.number === currentStep
                      ? "ring-1 ring-admin_primary/20"
                      : "cursor-not-allowed",
                    step.number > currentStep ? "opacity-50" : ""
                  )}
                  onClick={() => onStepClick(step.number)}
                  disabled={step.number > currentStep}
                >
                  {step.number < currentStep ? (
                    <CheckIcon className="w-6 h-6" />
                  ) : (
                    step.number
                  )}
                </button>

                <div className="mt-3 text-center">
                  <Typography
                    variant="admin_body"
                    className={twMerge(
                      "font-medium",
                      step.number <= currentStep
                        ? "text-admin_primary"
                        : "text-admin_text_secondary"
                    )}
                  >
                    {step.title}
                  </Typography>
                </div>
              </div>
              
              {index < steps.length - 1 && (
                <div className="w-[120px] h-px bg-admin_neutral_3/50 mx-4 -mt-16" />
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default StepHeader
